import React from "react";
import { getIsGuidePanel, setIsGuidePanel } from "@/reducers/guideSlice";
import { setIsMiniDashboardOpen } from "@/reducers/commonSlice";
import ButtonComponent from "@/components/button/Button";
import { useDispatch, useSelector } from "react-redux";
import "@/styles/components/switchDashboardCard.scss";
import { useNavigate } from "react-router-dom";

const SwitchDashBoard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isGuidePanel = useSelector(getIsGuidePanel);
  const handleSwitchToGuidePanel = () => {
    dispatch(setIsGuidePanel(!isGuidePanel));
    dispatch(setIsMiniDashboardOpen(false));
    navigate("/dashboard");
  };
  return (
    <div className="switch-guide-card-wrapper">
      <div className="guide-card-content">
        {!isGuidePanel ? (
          <div className="congratulation title-h5-1">Congratulations! You’re a Mentor Now.</div>
        ) : (
          <></>
        )}
        <div className="message body-b3">
          {isGuidePanel
            ? "Switch back to your Student Dashboard"
            : "Your request to become a mentor on our platform has been approved by Inforens."}
        </div>
        <div className="switch-button">
          <ButtonComponent
            label={`${isGuidePanel ? "Switch Dashboard" : "Switch to Mentor Dashboard"}`}
            varient="success"
            onClick={handleSwitchToGuidePanel}
          />
        </div>
      </div>
    </div>
  );
};

export default SwitchDashBoard;
